import logo from './image/tree.png';
import React from 'react';
import './App.css';
import Menu from './Cal/Menu';
import Festival from './Cal/FestivalCal';
import Transport from './Cal/TransportationCal';
import ComboSelect from 'react-combo-select';
import Co2Cost from './Cal/Co2CostCal';

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username:null,
            samplereturn:null,
            main_content_index:"0"
        };
    }

    componentDidMount() {
        // var postData = {'param1': "HpRequest"};
        // fetch('http://localhost:3001/api2')
        //     .then(res=>res.json())
        //     .then(data=>this.setState({username:data.username}));
        // fetch('http://localhost:3001/testApi2',{
        //     headers : {'Content-Type' : 'application/json'},
        //     method : 'POST',
        //     body: JSON.stringify(postData)})
        //     .then(res=>res.json())
        //     .then(data=>this.fn_set_reulstValue(data));
    }

    // fn_set_reulstValue =(data) => {
    //   alert(data.param1);
    //   this.setState({samplereturn:data.parm1});
    //
    // }

    set_main_content = (main_content) => {
        this.setState(prevState => ({
          main_content_index: main_content
        }));
      }

  render() {
    const {username} = this.state;
    const {samplereturn} = this.state;
    const {bodydata} = this.state;
    const {main_content_index} = this.state;
    let main_content = null;
    if(main_content_index==0){
      main_content = <Transport />;
   }else if(main_content_index==1){
      main_content = <Festival />;
    }else if(main_content_index==2){
      main_content = <Co2Cost/>;
    }

    return (
      <div className="App">
        <header className="App-header">
          <div className="header-item">
            <div>
              <img class="App-logo" src={logo} />
            </div>
          </div>
          <div className="header-item">
            <div className="textlogo">ECO-Festival</div>
          </div>
          <div className="header-item">
          </div>
        </header>
          <div className="nav-menu">
            <div className="nav-item">
              <Menu menuName="이동 탄소배출량  " content_index="0" setmenu={this.set_main_content}/>
            </div>
            <div className="nav-item">
              <Menu menuName="이벤트 탄소배출량" content_index="1" setmenu={this.set_main_content}/>
            </div>
            <div className="nav-item">
              <Menu menuName="탄소배출권 계산" content_index="2" setmenu={this.set_main_content}/>
            </div>
          </div>
          <div className="main-content">
            {main_content}
          </div>
      </div>
    );
    ;
  }
}

export default App;
